@if (loading()) {
	<nz-spin nzSimple nzSize="large"></nz-spin>
} @else {
	<app-setup-wizard-dynamic-table
		[enableEditButton]="enableEditButton()"
		[enableToggleDisableButton]="enableToggleDisableButton()"
		[enableRemoveButton]="enableRemoveButton()"
		[enableResetButton]="enableResetButton()"
		[selectedRow]="selectedRow()"
		[loading]="loading()"
		[upsertMode]="UPSERT_MODE"
		[rows]="rows()"
		[pageSize]="pageSize()"
		[columns]="columns()"
		(onToggleDisable)="onToggleDisableClick($event)"
		(onRemove)="onRemoveClick($event)"
		(onReset)="onResetClick($event)"
		(onEdit)="onEditClick($event)"
		(onNewPage)="onNewPage($event)"
	>
		<!-- Header templates (defines order/keys) -->
		<ng-template [appHeaderColumn]="UserCsvKeys.schoolIdOrEmail">
			{{ USER_CSV_LABELS[UserCsvKeys.schoolIdOrEmail] }}
		</ng-template>
		<ng-template [appHeaderColumn]="UserCsvKeys.group">{{ USER_CSV_LABELS[UserCsvKeys.group] }}</ng-template>
		<ng-template [appHeaderColumn]="UserCsvKeys.firstName">
			{{ USER_CSV_LABELS[UserCsvKeys.firstName] }}
		</ng-template>
		<ng-template [appHeaderColumn]="UserCsvKeys.lastName">{{ USER_CSV_LABELS[UserCsvKeys.lastName] }}</ng-template>
		<ng-template [appHeaderColumn]="UserCsvKeys.active">{{ USER_CSV_LABELS[UserCsvKeys.active] }}</ng-template>
		<ng-template appHeaderColumn="sections"><span nz-tooltip="Enrollment Status">Sections</span></ng-template>
		<ng-template appHeaderColumn="sections"><span nz-tooltip="Enrollment Status">Sections</span></ng-template>
		<ng-template appHeaderColumn="locations"><span nz-tooltip="Location Status">Locations</span></ng-template>
		<ng-template appHeaderColumn="enrolled"><span nz-tooltip="Enrolled">Enrolled</span></ng-template>
		<ng-template appHeaderColumn="historical">
			<span
				[nz-tooltip]="
					'Is the selected user currently enrolled in this section or' +
					' has the selected user been enrolled in this section at any time in the past?'
				"
			>
				Historical
			</span>
		</ng-template>
		<ng-template appHeaderColumn="status">Status</ng-template>

		<!-- Cell templates (matched by key; use {{ row.name }} etc.) -->
		<ng-template [appRowColumn]="UserCsvKeys.schoolIdOrEmail" [rowType]="rowType" let-row>
			<app-setup-wizard-before-after
				[data]="row"
				[key]="UserCsvKeys.schoolIdOrEmail"
			></app-setup-wizard-before-after>
		</ng-template>

		<ng-template [appRowColumn]="UserCsvKeys.group" [rowType]="rowType" let-row>
			<app-setup-wizard-before-after [data]="row" [key]="UserCsvKeys.group"></app-setup-wizard-before-after>
		</ng-template>

		<ng-template [appRowColumn]="UserCsvKeys.firstName" [rowType]="rowType" let-row>
			<app-setup-wizard-before-after [data]="row" [key]="UserCsvKeys.firstName"></app-setup-wizard-before-after>
		</ng-template>

		<ng-template [appRowColumn]="UserCsvKeys.lastName" [rowType]="rowType" let-row>
			<app-setup-wizard-before-after [data]="row" [key]="UserCsvKeys.lastName"></app-setup-wizard-before-after>
		</ng-template>

		<ng-template [appRowColumn]="UserCsvKeys.active" [rowType]="rowType" let-row>
			<app-setup-wizard-before-after [data]="row" [key]="UserCsvKeys.active"></app-setup-wizard-before-after>
		</ng-template>

		<ng-template appRowColumn="sections" [rowType]="rowType" let-row>
			<app-setup-wizard-user-sections-status
				[user]="row"
				[enableEditButton]="enableEditButton()"
				(onEdit)="onEditSectionsClick($event)"
			></app-setup-wizard-user-sections-status>
		</ng-template>

		<ng-template appRowColumn="locations" [rowType]="rowType" let-row>
			<app-setup-wizard-user-locations-status
				[user]="row"
				[enableEditButton]="enableEditButton()"
				(onEdit)="onEditLocationsClick($event)"
			></app-setup-wizard-user-locations-status>
		</ng-template>

		<ng-template appRowColumn="enrolled" [rowType]="rowType" let-row>
			{{ isUserEnrolledInSelectedSection(row) ? SetupWizardBooleanType.TRUE : SetupWizardBooleanType.FALSE }}
		</ng-template>

		<ng-template appRowColumn="historical" [rowType]="rowType" let-row>
			{{ isSelectedSectionHistorical(row) ? SetupWizardBooleanType.TRUE : SetupWizardBooleanType.FALSE }}
		</ng-template>

		<ng-template appRowColumn="status" [rowType]="rowType" let-row>
			<app-setup-wizard-before-after-status-with-links
				[data]="row"
				[user]="row"
				[upsertMode]="UPSERT_MODE"
			></app-setup-wizard-before-after-status-with-links>
		</ng-template>

		<ng-template #actions let-row>
			@if (enableEnrollButton() || enableUnenrollButton()) {
				@let section = selectedSection();
				@let isUserEnrolled = section ? isUserEnrolledInSelectedSection(row) : false;

				@if (enableEnrollButton()) {
					@if (!isUserEnrolled) {
						<button
							nz-button
							nzType="primary"
							nz-popconfirm
							nzPopconfirmTitle="Are you sure you want to enroll this user?"
							nzPopconfirmPlacement="bottom"
							(nzOnConfirm)="onEnrollClick(row)"
						>
							Enroll
						</button>
					}
				}
				@if (enableUnenrollButton()) {
					@if (isUserEnrolled) {
						<button
							nz-button
							nzType="default"
							nz-popconfirm
							nzPopconfirmTitle="Are you sure you want to unenroll this user?"
							nzPopconfirmPlacement="bottom"
							(nzOnConfirm)="onUnenrollClick(row)"
						>
							Unenroll
						</button>
					}
				}
			}

			@if (enableAssignButton() || enableUnassignButton()) {
				@let location = selectedLocation();
				@let isUserAssigned = location ? isUserAssignedInSelectedLocation(row) : false;

				@if (enableAssignButton()) {
					@if (!isUserAssigned) {
						<button
							nz-button
							nzType="primary"
							nz-popconfirm
							nzPopconfirmTitle="Are you sure you want to assign this user?"
							nzPopconfirmPlacement="bottom"
							(nzOnConfirm)="onAssignClick(row)"
						>
							Assign
						</button>
					}
				}
				@if (enableUnassignButton()) {
					@if (isUserAssigned) {
						<button
							nz-button
							nzType="default"
							nz-popconfirm
							nzPopconfirmTitle="Are you sure you want to unassign this user?"
							nzPopconfirmPlacement="bottom"
							(nzOnConfirm)="onUnassignClick(row)"
						>
							Unassign
						</button>
					}
				}
			}
		</ng-template>
	</app-setup-wizard-dynamic-table>
}
